import PropTypes from 'prop-types'
import React, { PureComponent, cloneElement } from 'react'
import { connect } from 'react-redux'
import tap from 'lodash/tap'
import Event from 'base/event'
import Hub from 'base/hub'

// Builds notifications from Redux state and passes them on to its children
class Provider extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    storeCreditAmount: PropTypes.string,
    hasWelcomeOffer: PropTypes.bool,
    hasViewedInvitePage: PropTypes.bool,
    hasInviteUrl: PropTypes.string,
    isMobile: PropTypes.bool,
  }

  getNotifications() {
    let storeCreditAmount = this.props.storeCreditAmount

    return tap([], notifications => {
      if (this.props.hasCredit && storeCreditAmount) {
        notifications.push({
          message: `You have ${storeCreditAmount} of Store Credit`,
          variant: 'credit',
          shouldShowInfoIcon: true,
          shouldShowDot: true,
        })
      }
    })
  }

  render() {
    let notifications = this.getNotifications()
    if (this.props.hasWelcomeOffer && this.props.welcomeOfferMessaging) {
      notifications = [
        ...notifications,
        {
          message: `${this.props.welcomeOfferMessaging} your first purchase`,
          submessage: 'Expires within 7 days of signup',
          variant: 'new-user',
          shouldShowInfoIcon: true,
          shouldShowDot: true,
        },
      ]
    }

    if (this.props.hasInviteUrl && notifications.length === 0) {
      notifications.push({
        message: 'Refer a friend and get $25 off your next purchase',
        submessage: 'See How',
        submessage_link: '/invite?source=menu',
        variant: 'invite',
        shouldShowInfoIcon: false,
        shouldShowDot: !this.props.hasViewedInvitePage,
        onClick: () => {
          if (!this.props.isMobile) {
            Hub.pub(Event.Navigation.ACCOUNT_CLICK, {
              type: 'invite',
              menu_type: 'dropdown',
            })
          }
        },
      })
    }

    return (
      <div className="notifications">
        {notifications.length > 0 && cloneElement(this.props.children, { notifications })}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    hasCredit: state.session.user?.has_credit || false,
    hasWelcomeOffer: state.session.visitor?.has_welcome_offer,
    welcomeOfferMessaging: state.session.visitor?.welcome_offer_messaging,
    totalCredits: state.session.user ? state.session.user.credits_total : null,
    storeCreditAmount: state.session.user?.credits_total,
    hasViewedInvitePage: state.session.visitor.viewedInvitePage,
    hasInviteUrl: state.session.user?.invite_url,
    isMobile: state.appConfig.isMobile,
  }
}

export let ProviderClass = Provider
export default connect(mapStateToProps)(Provider)
